/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpVmInstanceRestoreResult {
  /**
  * ID of the restored VM instance.
  */
  'instanceId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instanceId",
      "baseName": "instanceId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpVmInstanceRestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

